export const groupLabels = [
  {
    key: 'cloudidentity.googleapis.com/groups.discussion_forum',
    name: 'isMailing',
    title: 'Mailing',
    description: 'For email and distribution lists.',
    warning: '',
    readmoreLink: '',
    readmoreName: '',
    isUnremovable: true,
    chipStyles: {
      light: {
        bgcolor: '#fef3e7',
        color: '#654400',
      },
      dark: {
        bgcolor: '#ffcc00',
        color: '#121212',
      },
    },
  },
  {
    key: 'cloudidentity.googleapis.com/groups.security',
    name: 'isSecurity',
    title: 'Security',
    description:
      'To easily identify and manage groups you apply policies to, such as access control, add the Security label to them.',
    warning:
      "For controlling access to sensitive data and resources. You can't remove this label.",
    isUnremovable: true,
    readmoreLink:
      'https://support.google.com/a/answer/10607394?hl=en&src=supportwidget0&authuser=0',
    readmoreName: 'security groups',
    chipStyles: {
      light: {
        bgcolor: '#fae3e8',
        color: '#7b0128',
      },
      dark: {
        bgcolor: '#ef7a85',
        color: '#121212',
      },
    },
  },
  {
    key: 'cloudidentity.googleapis.com/groups.locked',
    name: 'isLocked',
    title: 'Locked',
    description:
      'Prevents direct changes to group memberships and properties, often used for groups synchronized with external identity systems.',
    warning: '',
    isUnremovable: false,
    readmoreLink:
      'https://support.google.com/a/answer/15634160?hl=en&src=supportwidget0&authuser=0',
    readmoreName: 'locked groups',
    chipStyles: {
      light: {
        bgcolor: '#fff3e0',
        color: '#e65100',
      },
      dark: {
        bgcolor: '#e65100',
        color: '#fff3e0',
      },
    },
  },
];
